// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Data Analytics page styling (scoped with the anp- prefix).
   Same visual language as Insights / Dashboard / Enquiries / Data Center:
   gradient hero, rounded cards, accent-tinted icon tiles. Accent colors come
   from the app-wide tokens (.accent-* in App.css). Every piece of text keeps a
   6:1 contrast ratio and is never smaller than 12px; entrance animations only
   slide (never fade) so text is never semi-transparent.
   ========================================================================== */

.anp-page {
  --anp-muted: #475569;
  --anp-line: rgba(148, 163, 184, 0.32);
  --anp-field-bg: #ffffff;
  --anp-field-border: #8a97a8;
  --anp-field-text: #111827;
}
.dark-theme.anp-page {
  --anp-muted: rgba(255, 255, 255, 0.72);
  --anp-line: rgba(255, 255, 255, 0.13);
  --anp-field-bg: #2a2f34;
  --anp-field-border: rgba(255, 255, 255, 0.28);
  --anp-field-text: #f1f5f9;
}

/* ---------- motion ---------- */
@keyframes anp-fade-up {
  from { transform: translateY(10px); }
  to   { transform: none; }
}
@keyframes anp-shimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
.anp-fade { animation: anp-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }

@media (prefers-reduced-motion: reduce) {
  .anp-fade, .anp-skel { animation: none !important; }
  .anp-card, .anp-hero-btn, .anp-hbar-fill { transition: none !important; }
}

/* ---------- hero ---------- */
.anp-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 8px 0 18px;
  padding: 26px 30px;
  border-radius: 22px;
  color: #fff;
  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);
  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);
}
.dark-theme .anp-hero {
  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}
.anp-hero::before,
.anp-hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.anp-hero::before {
  width: 260px; height: 260px;
  right: -60px; top: -110px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
}
.anp-hero::after {
  width: 200px; height: 200px;
  right: 22%; bottom: -120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
}
.anp-hero-text, .anp-hero-actions { position: relative; z-index: 1; }

.anp-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  background: rgba(6, 14, 40, 0.34);
  border: 1px solid rgba(255, 255, 255, 0.28);
}
.anp-hero-title {
  margin: 10px 0 4px;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.4px;
  color: #fff;
}
.anp-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }

.anp-hero-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.anp-hero-updated { font-size: 13px; font-weight: 600; color: #ffffff; }
.anp-hero .anp-hero-btn.btn {
  display: inline-flex;
  align-items: center;
  background: #fff;
  color: #1a3483;
  border: 0;
  border-radius: 999px;
  padding: 10px 20px;
  font-weight: 800;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.anp-hero .anp-hero-btn.btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 12px 22px rgba(0, 0, 0, 0.24); }
.anp-hero .anp-hero-btn.btn:disabled { opacity: 1; }

/* ---------- cards ---------- */
.anp-card {
  position: relative;
  border: 1px solid transparent;
  border-radius: 18px;
  background: #ffffff;
  color: #111827;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
}
.dark-theme .anp-card {
  background: #212529;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}

/* ---------- filter bar ---------- */
.anp-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px 24px;
  margin-bottom: 18px;
  padding: 14px 20px;
}
.anp-filter-group { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }
.anp-filter-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--anp-muted);
}
.anp-filter-note { flex: 1 1 260px; margin: 0; font-size: 13px; color: var(--anp-muted); }

.anp-seg {
  display: inline-flex;
  padding: 3px;
  border-radius: 999px;
  background: #e8ecf2;
}
.dark-theme .anp-seg { background: rgba(255, 255, 255, 0.1); }
.anp-seg button {
  border: 0;
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 13.5px;
  font-weight: 700;
  background: transparent;
  color: #1e293b;
  transition: background 0.15s ease, color 0.15s ease;
}
.dark-theme .anp-seg button { color: #f1f5f9; }
.anp-seg button:hover:not([aria-pressed="true"]) { background: rgba(15, 23, 42, 0.08); }
.dark-theme .anp-seg button:hover:not([aria-pressed="true"]) { background: rgba(255, 255, 255, 0.1); }
.anp-seg button[aria-pressed="true"] {
  background: #1a3483;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(26, 52, 131, 0.3);
}
.dark-theme .anp-seg button[aria-pressed="true"] { background: #2457b8; box-shadow: none; }
.anp-seg button:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.5); outline-offset: 2px; }
.anp-seg-sm button { padding: 4px 12px; font-size: 12.5px; }

.anp-date { display: inline-flex; align-items: center; gap: 8px; margin: 0; }
.anp-date span { font-size: 13px; font-weight: 700; color: var(--anp-muted); }
.anp-date input {
  height: 36px;
  padding: 0 10px;
  font-size: 13.5px;
  border-radius: 10px;
  border: 1px solid var(--anp-field-border);
  background: var(--anp-field-bg);
  color: var(--anp-field-text);
}
.dark-theme .anp-date input { color-scheme: dark; }
.anp-date input:focus { outline: 0; border-color: #2457b8; box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25); }

.anp-page .anp-btn-ghost.btn {
  border: 0;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  background: #e8ecf2;
}
.dark-theme .anp-btn-ghost.btn { color: #f1f5f9; background: #343a40; }
.anp-btn-ghost.btn:hover:not(:disabled) { color: #0f172a; background: #d9dfe8; }
.dark-theme .anp-btn-ghost.btn:hover:not(:disabled) { color: #ffffff; background: #444b52; }

.anp-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  background: #fee2e2;
  color: #7f1212;
}
.anp-error svg { font-size: 20px; flex-shrink: 0; }
.anp-error span { flex: 1 1; }
.dark-theme .anp-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }

.anp-body.is-refreshing { filter: saturate(0.65); transition: filter 0.2s ease; }

/* ---------- stat cards ---------- */
.anp-stat { overflow: hidden; padding: 18px 20px 16px; min-height: 158px; border-top: 4px solid var(--tmis-accent); }
.dark-theme .anp-stat { border-top-color: var(--tmis-accent-dark); }
.anp-stat-watermark {
  position: absolute;
  right: -12px; bottom: -16px;
  font-size: 92px;
  line-height: 1;
  color: var(--tmis-accent);
  opacity: 0.1;
  pointer-events: none;
}
.dark-theme .anp-stat-watermark { color: var(--tmis-accent-dark); opacity: 0.14; }
.anp-stat-top { display: flex; align-items: center; gap: 10px; }
.anp-stat-icon,
.anp-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .anp-stat-icon,
.dark-theme .anp-title-icon {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}
.anp-stat-icon { width: 40px; height: 40px; border-radius: 12px; font-size: 19px; }
.anp-stat-label {
  flex: 1 1;
  min-width: 0;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--anp-muted);
}
.anp-stat-value {
  position: relative;
  z-index: 1;
  margin: 14px 0 4px;
  font-size: 34px;
  font-weight: 850;
  line-height: 1.1;
  color: #0f172a;
}
.dark-theme .anp-stat-value { color: #ffffff; }
.anp-stat-note { position: relative; z-index: 1; font-size: 13px; color: var(--anp-muted); }

.anp-delta {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}
.anp-delta.good { color: #0d602d; background: #dcfce7; }
.anp-delta.bad { color: #a11616; background: #fee2e2; }
.anp-delta.flat { color: #475569; background: #e8ecf2; }
.dark-theme .anp-delta.good { color: #86efac; background: rgba(74, 222, 128, 0.14); }
.dark-theme .anp-delta.bad { color: #fcc4c4; background: rgba(248, 113, 113, 0.14); }
.dark-theme .anp-delta.flat { color: #cbd5e1; background: rgba(148, 163, 184, 0.16); }

/* ---------- chart cards ---------- */
.anp-chart { padding: 18px 20px 20px; }
.anp-chart-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
.anp-title-icon { width: 38px; height: 38px; border-radius: 12px; font-size: 18px; }
.anp-chart-titles { flex: 1 1; min-width: 0; }
.anp-chart-title { margin: 0; font-size: 16px; font-weight: 800; line-height: 1.25; }
.anp-chart-sub { margin: 1px 0 0; font-size: 12.5px; color: var(--anp-muted); }

.anp-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }
.anp-chip {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .anp-chip {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

.anp-chart-wrap { position: relative; }
.anp-svg { display: block; width: 100%; height: auto; overflow: visible; }

.anp-tooltip {
  position: absolute;
  transform: translate(-50%, -130%);
  background: #ffffff;
  color: #111827;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 10px;
  padding: 8px 10px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.15);
  pointer-events: none;
  white-space: nowrap;
  z-index: 5;
}
.anp-tooltip.dark { background: #1f2021; color: #ffffff; border-color: rgba(255, 255, 255, 0.2); }
.anp-tooltip-date { font-size: 12px; font-weight: 700; color: #475569; }
.anp-tooltip.dark .anp-tooltip-date { color: rgba(255, 255, 255, 0.78); }
.anp-tooltip-value { font-size: 14px; font-weight: 800; }

/* ---------- horizontal bars ---------- */
.anp-hbar-list { display: flex; flex-direction: column; gap: 12px; margin: 4px 0 0; padding: 0; list-style: none; }
.anp-hbar-row { display: grid; grid-template-columns: minmax(70px, 108px) 1fr auto; align-items: center; gap: 10px; }
.anp-hbar-label {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
}
.dark-theme .anp-hbar-label { color: #e5e7eb; }
.anp-hbar-track { height: 10px; border-radius: 999px; background: rgba(148, 163, 184, 0.22); overflow: hidden; }
.dark-theme .anp-hbar-track { background: rgba(255, 255, 255, 0.1); }
.anp-hbar-fill { height: 100%; min-width: 4px; border-radius: 999px; transition: width 0.4s ease; }
.anp-hbar-value {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 5px;
  min-width: 56px;
  font-size: 13.5px;
  font-weight: 800;
  color: #111827;
}
.dark-theme .anp-hbar-value { color: #ffffff; }
.anp-hbar-pct { font-size: 12px; font-weight: 600; color: var(--anp-muted); }

/* ---------- table view ---------- */
.anp-table-wrap { max-height: 270px; overflow: auto; border: 1px solid var(--anp-line); border-radius: 12px; }
.anp-table { width: 100%; border-collapse: collapse; font-size: 13.5px; }
.anp-table th {
  position: sticky;
  top: 0;
  padding: 8px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--anp-muted);
  background: #eef1f6;
  border-bottom: 1px solid var(--anp-line);
}
.dark-theme .anp-table th { background: #2a2f34; }
.anp-table td { padding: 8px 12px; border-bottom: 1px solid var(--anp-line); }
.anp-table tbody tr:last-child td { border-bottom: 0; }
.anp-num { font-weight: 800; }
.anp-muted { color: var(--anp-muted); }
.anp-page .text-end { text-align: right !important; }

/* ---------- loading / empty ---------- */
.anp-skel {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16) 25%, rgba(148, 163, 184, 0.34) 37%, rgba(148, 163, 184, 0.16) 63%);
  background-size: 400% 100%;
  animation: anp-shimmer 1.3s ease infinite;
}
.anp-skel-value { width: 110px; height: 36px; margin: 14px 0 6px; }
.anp-chart-skel { display: flex; flex-direction: column; gap: 14px; padding-top: 6px; }

.anp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 26px 12px;
  text-align: center;
  font-size: 14px;
  color: var(--anp-muted);
  border: 1px dashed var(--anp-line);
  border-radius: 14px;
}
.anp-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  font-size: 24px;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .anp-empty-icon {
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

/* ---------- footer ---------- */
.anp-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  font-size: 12.5px;
  color: var(--anp-muted);
}
.anp-live { padding: 2px 10px; border-radius: 999px; font-size: 12px; font-weight: 800; background: #0a5f34; color: #ffffff; }
.dark-theme .anp-live { background: #4ade80; color: #06210f; }

@media (max-width: 575.98px) {
  .anp-hero { padding: 20px; }
  .anp-hero-title { font-size: 26px; }
  .anp-filter { padding: 14px; }
  .anp-chart { padding: 16px 14px 18px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/analyticsPage.css"],"names":[],"mappings":"AAAA;;;;;;;+EAO+E;;AAE/E;EACE,oBAAoB;EACpB,qCAAqC;EACrC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,eAAe,EAAE;AAC1B;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;AACA,YAAY,sCAAsC,EAAE,8BAA8B,EAAE;;AAEpF;EACE,uBAAuB,0BAA0B,EAAE;EACnD,2CAA2C,2BAA2B,EAAE;AAC1E;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;AACA;EACE,0EAA0E;EAC1E,2CAA2C;AAC7C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,WAAW;EACzB,+EAA+E;AACjF;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,UAAU,EAAE,cAAc;EAC1B,+EAA+E;AACjF;AACA,oCAAoC,kBAAkB,EAAE,UAAU,EAAE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA,gBAAgB,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEhF,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACpF,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;AACzD;AACA,mDAAmD,2BAA2B,EAAE,2CAA2C,EAAE;AAC7H,uCAAuC,UAAU,EAAE;;AAEnD,gCAAgC;AAChC;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE;AACpF;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;AACA,mBAAmB,eAAe,EAAE,SAAS,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAEzF;EACE,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA,uBAAuB,oCAAoC,EAAE;AAC7D;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;AACA,8BAA8B,cAAc,EAAE;AAC9C,mDAAmD,kCAAkC,EAAE;AACvF,+DAA+D,oCAAoC,EAAE;AACrG;EACE,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;AACA,mDAAmD,mBAAmB,EAAE,gBAAgB,EAAE;AAC1F,gCAAgC,yCAAyC,EAAE,mBAAmB,EAAE;AAChG,qBAAqB,iBAAiB,EAAE,iBAAiB,EAAE;;AAE3D,YAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,SAAS,EAAE;AAC5E,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC7E;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,8BAA8B,kBAAkB,EAAE;AAClD,wBAAwB,UAAU,EAAE,qBAAqB,EAAE,6CAA6C,EAAE;;AAE1G;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA,iCAAiC,cAAc,EAAE,mBAAmB,EAAE;AACtE,0CAA0C,cAAc,EAAE,mBAAmB,EAAE;AAC/E,sDAAsD,cAAc,EAAE,mBAAmB,EAAE;;AAE3F;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,iBAAiB,eAAe,EAAE,cAAc,EAAE;AAClD,kBAAkB,SAAO,EAAE;AAC3B,yBAAyB,qCAAqC,EAAE,cAAc,EAAE;;AAEhF,0BAA0B,sBAAsB,EAAE,4BAA4B,EAAE;;AAEhF,qCAAqC;AACrC,YAAY,gBAAgB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,wCAAwC,EAAE;AACpH,wBAAwB,yCAAyC,EAAE;AACnE;EACE,kBAAkB;EAClB,YAAY,EAAE,aAAa;EAC3B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;AACA,kCAAkC,8BAA8B,EAAE,aAAa,EAAE;AACjF,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC/D;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;;EAEE,wEAAwE;EACxE,4DAA4D;AAC9D;AACA,iBAAiB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAClF;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA,8BAA8B,cAAc,EAAE;AAC9C,iBAAiB,kBAAkB,EAAE,UAAU,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAE3F;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,kBAAkB,cAAc,EAAE,mBAAmB,EAAE;AACvD,iBAAiB,cAAc,EAAE,mBAAmB,EAAE;AACtD,kBAAkB,cAAc,EAAE,mBAAmB,EAAE;AACvD,8BAA8B,cAAc,EAAE,oCAAoC,EAAE;AACpF,6BAA6B,cAAc,EAAE,qCAAqC,EAAE;AACpF,8BAA8B,cAAc,EAAE,qCAAqC,EAAE;;AAErF,sCAAsC;AACtC,aAAa,uBAAuB,EAAE;AACtC,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtF,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACnF,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACpF,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;;AAE9E,aAAa,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC3E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,wEAAwE;EACxE,4DAA4D;AAC9D;;AAEA,kBAAkB,kBAAkB,EAAE;AACtC,WAAW,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAEzE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE,sCAAsC,EAAE;AACjG,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,sCAAsC,gCAAgC,EAAE;AACxE,qBAAqB,eAAe,EAAE,gBAAgB,EAAE;;AAExD,0CAA0C;AAC1C,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAClH,gBAAgB,aAAa,EAAE,mDAAmD,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACpH;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,8BAA8B,cAAc,EAAE;AAC9C,kBAAkB,YAAY,EAAE,oBAAoB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AAC/G,8BAA8B,oCAAoC,EAAE;AACpE,iBAAiB,YAAY,EAAE,cAAc,EAAE,oBAAoB,EAAE,2BAA2B,EAAE;AAClG;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,8BAA8B,cAAc,EAAE;AAC9C,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAE5E,qCAAqC;AACrC,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,iCAAiC,EAAE,mBAAmB,EAAE;AAC7G,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACxE;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA,4BAA4B,mBAAmB,EAAE;AACjD,gBAAgB,iBAAiB,EAAE,wCAAwC,EAAE;AAC7E,oCAAoC,gBAAgB,EAAE;AACtD,WAAW,gBAAgB,EAAE;AAC7B,aAAa,uBAAuB,EAAE;AACtC,sBAAsB,4BAA4B,EAAE;;AAEpD,0CAA0C;AAC1C;EACE,cAAc;EACd,kBAAkB;EAClB,+HAA+H;EAC/H,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA,kBAAkB,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAClE,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEtF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,wEAAwE;EACxE,4DAA4D;AAC9D;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;AACA,YAAY,iBAAiB,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC7H,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,YAAY,aAAa,EAAE;EAC3B,kBAAkB,eAAe,EAAE;EACnC,cAAc,aAAa,EAAE;EAC7B,aAAa,uBAAuB,EAAE;AACxC","sourcesContent":["/* ==========================================================================\n   Data Analytics page styling (scoped with the anp- prefix).\n   Same visual language as Insights / Dashboard / Enquiries / Data Center:\n   gradient hero, rounded cards, accent-tinted icon tiles. Accent colors come\n   from the app-wide tokens (.accent-* in App.css). Every piece of text keeps a\n   6:1 contrast ratio and is never smaller than 12px; entrance animations only\n   slide (never fade) so text is never semi-transparent.\n   ========================================================================== */\n\n.anp-page {\n  --anp-muted: #475569;\n  --anp-line: rgba(148, 163, 184, 0.32);\n  --anp-field-bg: #ffffff;\n  --anp-field-border: #8a97a8;\n  --anp-field-text: #111827;\n}\n.dark-theme.anp-page {\n  --anp-muted: rgba(255, 255, 255, 0.72);\n  --anp-line: rgba(255, 255, 255, 0.13);\n  --anp-field-bg: #2a2f34;\n  --anp-field-border: rgba(255, 255, 255, 0.28);\n  --anp-field-text: #f1f5f9;\n}\n\n/* ---------- motion ---------- */\n@keyframes anp-fade-up {\n  from { transform: translateY(10px); }\n  to   { transform: none; }\n}\n@keyframes anp-shimmer {\n  0%   { background-position: 100% 0; }\n  100% { background-position: 0 0; }\n}\n.anp-fade { animation: anp-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }\n\n@media (prefers-reduced-motion: reduce) {\n  .anp-fade, .anp-skel { animation: none !important; }\n  .anp-card, .anp-hero-btn, .anp-hbar-fill { transition: none !important; }\n}\n\n/* ---------- hero ---------- */\n.anp-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin: 8px 0 18px;\n  padding: 26px 30px;\n  border-radius: 22px;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);\n  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);\n}\n.dark-theme .anp-hero {\n  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n}\n.anp-hero::before,\n.anp-hero::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n}\n.anp-hero::before {\n  width: 260px; height: 260px;\n  right: -60px; top: -110px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);\n}\n.anp-hero::after {\n  width: 200px; height: 200px;\n  right: 22%; bottom: -120px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);\n}\n.anp-hero-text, .anp-hero-actions { position: relative; z-index: 1; }\n\n.anp-hero-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  background: rgba(6, 14, 40, 0.34);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n.anp-hero-title {\n  margin: 10px 0 4px;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n.anp-hero-sub { margin: 0; max-width: 620px; color: #ffffff; font-size: 14.5px; }\n\n.anp-hero-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n.anp-hero-updated { font-size: 13px; font-weight: 600; color: #ffffff; }\n.anp-hero .anp-hero-btn.btn {\n  display: inline-flex;\n  align-items: center;\n  background: #fff;\n  color: #1a3483;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 20px;\n  font-weight: 800;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.anp-hero .anp-hero-btn.btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 12px 22px rgba(0, 0, 0, 0.24); }\n.anp-hero .anp-hero-btn.btn:disabled { opacity: 1; }\n\n/* ---------- cards ---------- */\n.anp-card {\n  position: relative;\n  border: 1px solid transparent;\n  border-radius: 18px;\n  background: #ffffff;\n  color: #111827;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);\n}\n.dark-theme .anp-card {\n  background: #212529;\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n\n/* ---------- filter bar ---------- */\n.anp-filter {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px 24px;\n  margin-bottom: 18px;\n  padding: 14px 20px;\n}\n.anp-filter-group { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }\n.anp-filter-label {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--anp-muted);\n}\n.anp-filter-note { flex: 1 1 260px; margin: 0; font-size: 13px; color: var(--anp-muted); }\n\n.anp-seg {\n  display: inline-flex;\n  padding: 3px;\n  border-radius: 999px;\n  background: #e8ecf2;\n}\n.dark-theme .anp-seg { background: rgba(255, 255, 255, 0.1); }\n.anp-seg button {\n  border: 0;\n  border-radius: 999px;\n  padding: 7px 16px;\n  font-size: 13.5px;\n  font-weight: 700;\n  background: transparent;\n  color: #1e293b;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.dark-theme .anp-seg button { color: #f1f5f9; }\n.anp-seg button:hover:not([aria-pressed=\"true\"]) { background: rgba(15, 23, 42, 0.08); }\n.dark-theme .anp-seg button:hover:not([aria-pressed=\"true\"]) { background: rgba(255, 255, 255, 0.1); }\n.anp-seg button[aria-pressed=\"true\"] {\n  background: #1a3483;\n  color: #ffffff;\n  box-shadow: 0 4px 10px rgba(26, 52, 131, 0.3);\n}\n.dark-theme .anp-seg button[aria-pressed=\"true\"] { background: #2457b8; box-shadow: none; }\n.anp-seg button:focus-visible { outline: 3px solid rgba(45, 82, 196, 0.5); outline-offset: 2px; }\n.anp-seg-sm button { padding: 4px 12px; font-size: 12.5px; }\n\n.anp-date { display: inline-flex; align-items: center; gap: 8px; margin: 0; }\n.anp-date span { font-size: 13px; font-weight: 700; color: var(--anp-muted); }\n.anp-date input {\n  height: 36px;\n  padding: 0 10px;\n  font-size: 13.5px;\n  border-radius: 10px;\n  border: 1px solid var(--anp-field-border);\n  background: var(--anp-field-bg);\n  color: var(--anp-field-text);\n}\n.dark-theme .anp-date input { color-scheme: dark; }\n.anp-date input:focus { outline: 0; border-color: #2457b8; box-shadow: 0 0 0 3px rgba(45, 82, 196, 0.25); }\n\n.anp-page .anp-btn-ghost.btn {\n  border: 0;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e293b;\n  background: #e8ecf2;\n}\n.dark-theme .anp-btn-ghost.btn { color: #f1f5f9; background: #343a40; }\n.anp-btn-ghost.btn:hover:not(:disabled) { color: #0f172a; background: #d9dfe8; }\n.dark-theme .anp-btn-ghost.btn:hover:not(:disabled) { color: #ffffff; background: #444b52; }\n\n.anp-error {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: 14px;\n  font-size: 14px;\n  font-weight: 600;\n  background: #fee2e2;\n  color: #7f1212;\n}\n.anp-error svg { font-size: 20px; flex-shrink: 0; }\n.anp-error span { flex: 1; }\n.dark-theme .anp-error { background: rgba(248, 113, 113, 0.14); color: #fcc4c4; }\n\n.anp-body.is-refreshing { filter: saturate(0.65); transition: filter 0.2s ease; }\n\n/* ---------- stat cards ---------- */\n.anp-stat { overflow: hidden; padding: 18px 20px 16px; min-height: 158px; border-top: 4px solid var(--tmis-accent); }\n.dark-theme .anp-stat { border-top-color: var(--tmis-accent-dark); }\n.anp-stat-watermark {\n  position: absolute;\n  right: -12px; bottom: -16px;\n  font-size: 92px;\n  line-height: 1;\n  color: var(--tmis-accent);\n  opacity: 0.1;\n  pointer-events: none;\n}\n.dark-theme .anp-stat-watermark { color: var(--tmis-accent-dark); opacity: 0.14; }\n.anp-stat-top { display: flex; align-items: center; gap: 10px; }\n.anp-stat-icon,\n.anp-title-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .anp-stat-icon,\n.dark-theme .anp-title-icon {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n.anp-stat-icon { width: 40px; height: 40px; border-radius: 12px; font-size: 19px; }\n.anp-stat-label {\n  flex: 1;\n  min-width: 0;\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--anp-muted);\n}\n.anp-stat-value {\n  position: relative;\n  z-index: 1;\n  margin: 14px 0 4px;\n  font-size: 34px;\n  font-weight: 850;\n  line-height: 1.1;\n  color: #0f172a;\n}\n.dark-theme .anp-stat-value { color: #ffffff; }\n.anp-stat-note { position: relative; z-index: 1; font-size: 13px; color: var(--anp-muted); }\n\n.anp-delta {\n  position: relative;\n  z-index: 1;\n  flex-shrink: 0;\n  padding: 2px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n.anp-delta.good { color: #0d602d; background: #dcfce7; }\n.anp-delta.bad { color: #a11616; background: #fee2e2; }\n.anp-delta.flat { color: #475569; background: #e8ecf2; }\n.dark-theme .anp-delta.good { color: #86efac; background: rgba(74, 222, 128, 0.14); }\n.dark-theme .anp-delta.bad { color: #fcc4c4; background: rgba(248, 113, 113, 0.14); }\n.dark-theme .anp-delta.flat { color: #cbd5e1; background: rgba(148, 163, 184, 0.16); }\n\n/* ---------- chart cards ---------- */\n.anp-chart { padding: 18px 20px 20px; }\n.anp-chart-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }\n.anp-title-icon { width: 38px; height: 38px; border-radius: 12px; font-size: 18px; }\n.anp-chart-titles { flex: 1; min-width: 0; }\n.anp-chart-title { margin: 0; font-size: 16px; font-weight: 800; line-height: 1.25; }\n.anp-chart-sub { margin: 1px 0 0; font-size: 12.5px; color: var(--anp-muted); }\n\n.anp-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }\n.anp-chip {\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .anp-chip {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n.anp-chart-wrap { position: relative; }\n.anp-svg { display: block; width: 100%; height: auto; overflow: visible; }\n\n.anp-tooltip {\n  position: absolute;\n  transform: translate(-50%, -130%);\n  background: #ffffff;\n  color: #111827;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  border-radius: 10px;\n  padding: 8px 10px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.15);\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 5;\n}\n.anp-tooltip.dark { background: #1f2021; color: #ffffff; border-color: rgba(255, 255, 255, 0.2); }\n.anp-tooltip-date { font-size: 12px; font-weight: 700; color: #475569; }\n.anp-tooltip.dark .anp-tooltip-date { color: rgba(255, 255, 255, 0.78); }\n.anp-tooltip-value { font-size: 14px; font-weight: 800; }\n\n/* ---------- horizontal bars ---------- */\n.anp-hbar-list { display: flex; flex-direction: column; gap: 12px; margin: 4px 0 0; padding: 0; list-style: none; }\n.anp-hbar-row { display: grid; grid-template-columns: minmax(70px, 108px) 1fr auto; align-items: center; gap: 10px; }\n.anp-hbar-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e293b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.dark-theme .anp-hbar-label { color: #e5e7eb; }\n.anp-hbar-track { height: 10px; border-radius: 999px; background: rgba(148, 163, 184, 0.22); overflow: hidden; }\n.dark-theme .anp-hbar-track { background: rgba(255, 255, 255, 0.1); }\n.anp-hbar-fill { height: 100%; min-width: 4px; border-radius: 999px; transition: width 0.4s ease; }\n.anp-hbar-value {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 5px;\n  min-width: 56px;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #111827;\n}\n.dark-theme .anp-hbar-value { color: #ffffff; }\n.anp-hbar-pct { font-size: 12px; font-weight: 600; color: var(--anp-muted); }\n\n/* ---------- table view ---------- */\n.anp-table-wrap { max-height: 270px; overflow: auto; border: 1px solid var(--anp-line); border-radius: 12px; }\n.anp-table { width: 100%; border-collapse: collapse; font-size: 13.5px; }\n.anp-table th {\n  position: sticky;\n  top: 0;\n  padding: 8px 12px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--anp-muted);\n  background: #eef1f6;\n  border-bottom: 1px solid var(--anp-line);\n}\n.dark-theme .anp-table th { background: #2a2f34; }\n.anp-table td { padding: 8px 12px; border-bottom: 1px solid var(--anp-line); }\n.anp-table tbody tr:last-child td { border-bottom: 0; }\n.anp-num { font-weight: 800; }\n.anp-muted { color: var(--anp-muted); }\n.anp-page .text-end { text-align: right !important; }\n\n/* ---------- loading / empty ---------- */\n.anp-skel {\n  display: block;\n  border-radius: 8px;\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.16) 25%, rgba(148, 163, 184, 0.34) 37%, rgba(148, 163, 184, 0.16) 63%);\n  background-size: 400% 100%;\n  animation: anp-shimmer 1.3s ease infinite;\n}\n.anp-skel-value { width: 110px; height: 36px; margin: 14px 0 6px; }\n.anp-chart-skel { display: flex; flex-direction: column; gap: 14px; padding-top: 6px; }\n\n.anp-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 26px 12px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--anp-muted);\n  border: 1px dashed var(--anp-line);\n  border-radius: 14px;\n}\n.anp-empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  font-size: 24px;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .anp-empty-icon {\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n/* ---------- footer ---------- */\n.anp-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  font-size: 12.5px;\n  color: var(--anp-muted);\n}\n.anp-live { padding: 2px 10px; border-radius: 999px; font-size: 12px; font-weight: 800; background: #0a5f34; color: #ffffff; }\n.dark-theme .anp-live { background: #4ade80; color: #06210f; }\n\n@media (max-width: 575.98px) {\n  .anp-hero { padding: 20px; }\n  .anp-hero-title { font-size: 26px; }\n  .anp-filter { padding: 14px; }\n  .anp-chart { padding: 16px 14px 18px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
